'use strict';

var $ = require('jquery');
var privacy = require('./product/privacy');
const Dialog = require('../lib/dialog').default;
var toggle = require('./toggle');
var util = require('../utils/util');
var $body = $('.body');
var eventsDefined = false;

/**
 * Simple Cookie banner
 * Manages a cookie policy banner's behavior. Sets 'cookieBannerClosed' cookie upon user's closure to prevent re-displaying.
 *
 */
function simpleCookieBanner() {
    const $simpleCookieBanner = $('.simple-cookie-policy-banner-content-section');

    if (!$simpleCookieBanner.length) {
        return;
    }

    let $parentDialog = $simpleCookieBanner.closest('dialog.ui-dialog.privacy-overlay');

    if ($parentDialog.length) {
        $parentDialog.addClass('simple-cookie-policy-msg-container');
        $('body').removeClass('ui-dialog-position-fixed');
        $('div.ui-widget-overlay').remove();
    }

    // Check if 'cookieBannerClosed' cookie is already set and if so, remove the banner
    if (document.cookie.split(';').some(item => item.trim().startsWith('cookieBannerClosed='))) {
        $parentDialog.remove();
        return;
    }

    $simpleCookieBanner.on('click', 'a.cookie-banner-close', function (e) {
        e.preventDefault();
        // Set a session cookie named 'cookieBannerClosed'
        document.cookie = 'cookieBannerClosed=true;path=/';
        $parentDialog.remove();
    });
}

import {throttle} from '../components/custom-lodash';

/**
 * Initialize the privacy tabs.
 *
 * @param $privacyLevelSetting jQuery privacy level settings element
 */
function initOverlayTabs($privacyLevelSetting) {
    var $cookieLevelTabs = $('.cookie-privacy-setting-detail .cookie-privacy-level-detail-tabs');
    var $tabs;
    var $inputs;

    if ($cookieLevelTabs.length) {
        $tabs = $cookieLevelTabs.find('.tab');
        $inputs = $privacyLevelSetting.find('.switch input');
        $cookieLevelTabs.show();
    }

    return {
        $tabs: $tabs,
        $inputs: $inputs
    };
}

/**
 * Confirm the levels and send the "form".
 *
 * @param levelData the comma separated level data string
 */
function confirmLevels(levelData, disallow, allow) {
    var dataObj = {
        levels: levelData
    };

    if (typeof disallow != 'undefined' && disallow !== null && disallow !== '') {
        dataObj.disallow = disallow;
    }
    if (typeof allow != 'undefined' && allow !== null && allow !== '') {
        dataObj.allow = allow;
    }

    $.ajax({
        type: 'POST',
        url: Urls.updatePrivacyCookie,
        data: dataObj,
        success: function () {
            // eslint-disable-next-line no-restricted-globals
            location.reload();
        }
    });
}

/**
 * Initializes the privacy settings "form".
 *
 * @param $privacyLevelSetting jQuery privacy level settings element
 * @param $privacyToggleList jQuery cookie toggle list
 */
function initPrivacyLevelSetting($privacyLevelSetting, $privacyToggleList) {
    var $allLevelInputs = $privacyLevelSetting.find('input[data-privacylevel]:not([data-cookiename])');
    var $levelInputs = $allLevelInputs.filter(':not([disabled])');
    var $allCookieInputs = $privacyToggleList.find('input[data-cookiename]');
    var $cookieInputs = $allCookieInputs.filter(':not([disabled])');
    var tabData = initOverlayTabs($privacyLevelSetting);

    $('.privacy-overlay-ctas')
        .find('.confirm-button')
        .on('click', function (event) {
            var levels = [];
            var disallow = [];
            var allow = [];

            // add fix position on body to avoid page scoll
            $body.removeClass('ui-dialog-position-fixed');

            if ($(this).hasClass('check-all-button')) {
                $cookieInputs.each(function () {
                    var $this = $(this);
                    $this.prop('checked', true).trigger('change');
                });
            }

            $allLevelInputs.each(function () {
                var $this = $(this);

                if ($this.is(':checked')) {
                    levels.push('level' + $this.data('privacylevel'));
                }
            });

            $allCookieInputs.each(function () {
                var $this = $(this);

                ($this.is(':checked') ? allow : disallow).push($this.data('cookiename'));
            });

            event.preventDefault();
            confirmLevels(levels.join(','), disallow.join(','), allow.join(','));
        });

    $levelInputs.on('change', function () {
        var $this = $(this);
        var $cookieElements = $cookieInputs.filter('[data-privacylevel="' + $this.data('privacylevel') + '"]');

        $cookieElements.prop('checked', $this.is(':checked'));
    });

    $cookieInputs.on('change', function () {
        var $this = $(this);
        var currentLevel = $this.data('privacylevel');
        var $levelElement = $levelInputs.filter('[data-privacylevel="' + currentLevel + '"]');
        var state = true;

        if (!$this.is(':checked')) {
            state =
                $cookieInputs.filter('[data-privacylevel="' + currentLevel + '"]').filter(function () {
                    return $(this).is(':checked');
                }).length > 0;
        }

        $levelElement.prop('checked', state);
    });
}

/**
 * Initializes the overlay start "form" (with default level settings).
 *
 * @param $overlayStart
 */
function initOverlayStart($overlayStart) {
    $overlayStart.find('.confirm-button').on('click', function (event) {
        // add fix position on body to avoid page scoll
        $body.removeClass('ui-dialog-position-fixed');

        event.preventDefault();
        confirmLevels($overlayStart.data('level-string'));
    });
}

/**
 * @description Updates the privacy setting (privacy cookie and session variables)
 */
function initNavigation(dialog) {
    var $overlay = $('.privacy-overlay');

    if ($overlay) {
        var $controlls = $overlay.find('.overlay-navigation');
        var $privacyLevelSetting = $overlay.find('.cookie-privacy-level-setting');
        var $privacyToggleList = $overlay.find('.cookie-privacy-setting-detail-toggle-list');
        var $overlayStart = $overlay.find('.overlay-start');
        var $overlayContent = $overlay.find('.ui-dialog-content');

        $('.landing-1774 .privacy-overlay').on('click', '.overlay-navigation', function () {
            var $this = $(this);
            $this.addClass('tapped');
            setTimeout(function () {
                $this.removeClass('tapped');
            }, 200);
        });

        $controlls.each(function () {
            $(this).on('click', function (event) {
                var href = $(this).attr('href');

                event.preventDefault();
                dialog.loadContent({
                    url: href,
                    callback: function () {
                        initNavigation(dialog);
                        initDialogScroll();
                        $overlayContent.animate(
                            {
                                scrollTop: 0
                            },
                            300
                        );
                        $overlay.removeClass('overlay-expanded');
                        if ($('.cookies-assets-wrapper').length) {
                            $overlayContent.addClass('webkit-cookie-scroller');
                        } else {
                            $overlayContent.removeClass('webkit-cookie-scroller');
                        }
                    }
                });
            });
        });

        if ($overlayStart.length) {
            initOverlayStart($overlayStart);
        }

        if ($privacyLevelSetting.length && $privacyToggleList.length) {
            initPrivacyLevelSetting($privacyLevelSetting, $privacyToggleList);
            toggle.init($privacyToggleList, true);
        }
    }
}

function initDialogScroll() {
    var $overlay = $('.privacy-overlay');
    var windowHeight = $(window).height();
    var headerHeight = $('.header-main').outerHeight();
    var is1774 = $('.landing-1774').length;
    var overlayHeight = windowHeight;
    var overlayHeightSmall = windowHeight - headerHeight;
    var contentHeight = 0;
    var startPosition = 10;
    const $cookieScroller = $('.cookie-scroller');

    if (is1774) {
        headerHeight = 163;
        startPosition = -10;
    }

    if (!is1774) {
        $('.cookie-privacy-overlay-top').addClass('default-overlay');

        if ($(window).width() >= Breakpoints.Mobile) {
            $overlay.css('max-height', overlayHeightSmall);

            $cookieScroller.on('scroll wheel touchmove mouseover', function () {
                contentHeight = $(this)[0].scrollHeight;

                if (contentHeight + headerHeight > windowHeight) {
                    $overlay.addClass('to-top');
                    if (contentHeight > windowHeight + headerHeight) {
                        $overlay.css('max-height', overlayHeight);
                    } else {
                        $overlay.css('max-height', overlayHeightSmall);
                    }
                }

                if ($('.cookie-start-indicator').offset().top > startPosition) {
                    $overlay.removeClass('to-top');
                    $overlay.removeClass('to-bottom');
                }

                if ($('.cookie-end-indicator').offset().top <= windowHeight && contentHeight > windowHeight) {
                    $overlay.addClass('to-bottom');
                } else {
                    $('.privacy-overlay').removeClass('to-bottom');
                }
            });
        }
    } else {
        $cookieScroller.on(
            'scroll wheel touchmove mouseover',
            throttle(() => {
                const scrollerOuterHeight = $cookieScroller.outerHeight();
                if (scrollerOuterHeight > windowHeight) {
                    if (
                        !$overlay.hasClass('overlay-expanded') &&
                        scrollerOuterHeight <= $overlay.children('#dialog-container').scrollTop() + windowHeight
                    ) {
                        $overlay.addClass('to-top');
                    } else {
                        $overlay.removeClass('to-top');
                    }
                }
            }, 200)
        );
    }
}

/**
 * @description Initialize the privacy dialog to prevent user action on the site without permission
 * @return {Dialog} dialog
 */
function initPrivacyOverlay() {
    var privacySetting = privacy.getPrivacySettings();
    var privacyLevels = privacy.getPrivacyLevels();
    var is1774 = $('.landing-1774').length > 0;

    const dialog = new Dialog({
        additionalClasses: ['privacy-overlay', 'no-close'],
        useLegacyBackdrop: true,
        backdropClasses: ['ui-privacy-overlay'],
        useLegacyContainer: true,
        canCloseOnBackdropClick: false,
        isModal: false,
        url: is1774 ? util.appendParamToURL(Urls.privacyDialogSettings, 'is1774', is1774) : Urls.privacyDialogSettings,
        callback: () => {
            initNavigation(dialog);
            initDialogScroll();
            simpleCookieBanner();
        }
    });

    if (privacySetting == null && privacyLevels == null) {
        // add fix position on body to avoid page scoll
        $body.addClass('ui-dialog-position-fixed');
        dialog.open();
    }

    if (!eventsDefined) {
        eventsDefined = true;

        $('body').on('click', '.toggle-cookies-content', function (e) {
            var is1774 = $('.landing-1774').length;
            e.preventDefault();

            $('.cookie-privacy-setting-detail').slideToggle(300, function () {
                if ($('.toggle-cookies-content').hasClass('active') && $(window).width() < Breakpoints.Mobile) {
                    $('.privacy-overlay .ui-dialog-content').animate(
                        {
                            scrollTop: $('.cookie-privacy-level-setting').offset().top - 30
                        },
                        400
                    );
                }
            });

            $(this).toggleClass('active');
            if (is1774 > 0) {
                $('.privacy-overlay').toggleClass('overlay-expanded');
            }

            if ($(this).hasClass('active')) {
                $(this).text($(this).data('show-less'));
            } else {
                $(this).text($(this).data('show-more'));
            }
        });

        $('body').on('click', '.toggle', function (e) {
            e.preventDefault();
            if ($(this).hasClass('expanded')) {
                $(this).find('.content-asset span').text($('.toggle-list.privacy').data('read-more'));
            } else {
                $(this).find('.content-asset span').text($('.toggle-list.privacy').data('read-less'));
            }
        });

        $('body').on('click', '.cookie-privacy-overlay-top', function (e) {
            var $legalTextH = $('.cookie-privacy-overlay-start-wrapper').outerHeight();
            var $levelSettH = $('.cookie-privacy-level-setting').outerHeight();
            var $totalHeight = $legalTextH + $levelSettH;
            var $container = $(this);
            var $fadedOverlay = $('.faded-overlay');
            var $dialogContent = $('.ui-dialog-content');

            $dialogContent.addClass('expanded');
            $container
                .css({
                    // Set height to prevent instant jumpdown when max height is removed
                    height: $container.height(),
                    'max-height': 9999
                })
                .animate({
                    height: $totalHeight
                });

            // fade out overlay
            $fadedOverlay.fadeOut();
        });

        $('body').on(
            'click',
            '.toggle-cookies-content, .cookie-privacy-overlay-top, .overlay-navigation',
            function (e) {
                var $dialogContent = $('.ui-dialog-content');

                $dialogContent.addClass('expanded');
            }
        );

        if ($('.site-container .new-header').length > 0) {
            $('.ui-dialog.privacy-overlay .ui-dialog-content').addClass('new-header');
        }
    }

    return dialog;
}

module.exports.initPrivacyOverlay = initPrivacyOverlay;
